import { lazy } from 'react';
const ProductCover = lazy(() => import('./ProductCover'));

const ProductCoverRoutes = [
  {
    path: '/productcover',
    component: ProductCover
  }
];

export default ProductCoverRoutes;
